import store from '../'

let resource = store.defineResource({
  name: "ping"
})

export default resource



// WEBPACK FOOTER //
// ./src/store/models/ping.js